var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 546,
    height: 221,
    viewBox: "0 0 546 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_146_2378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M526 208C526 189.352 519.443 170.887 506.703 153.659C493.964 136.431 475.291 120.777 451.752 107.591C428.212 94.4049 400.266 83.9453 369.51 76.8091C338.754 69.6729 305.79 66 272.5 66C239.21 66 206.246 69.6729 175.49 76.8091C144.734 83.9453 116.788 94.4049 93.2484 107.591C69.7088 120.777 51.0361 136.431 38.2965 153.659C25.557 170.887 19 189.352 19 208L272.5 208H526Z",
    fill: "#FFF4D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_146_2378",
    x: -46.4,
    y: 0.599998,
    width: 637.8,
    height: 272.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32.7,
    result: "effect1_foregroundBlur_146_2378"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse);
export default __webpack_public_path__ + "static/media/Ellipse.63ceef246ac78058a37faf5cebd09dd2.svg";
export { ForwardRef as ReactComponent };